<template>
  <div class="flex bg-light-grey rounded mb-4 mobile-column">
    <div
      class="flex flex-column flex-centered col bg-grey p-16 mobile-full"
      style="flex-basis: 0%; min-width: 320px">
      <h5>Unidade</h5>
      <h6 v-if="boleto.unidade">{{ boleto.unidade.descricao }}</h6>
      <h6 v-if="boleto.imovel">
        {{ boleto.imovel.subcodigo }} - {{ boleto.imovel.filial.abrev }}
      </h6>
      <!--<router-link :to="`/financeiro/segunda-via/detalhe/${boleto.competencia}/${boleto.codigo}`" class="default-button full" style="margin: 0;"><i class="mdi mdi-download"></i></router-link>-->
      <!--
                <router-link
                :to="`/financeiro/segunda-via/detalhe/${boleto.competencia}/${boleto.codigo}`"
                class="default-button full"
                style="margin: 0;"
            >ACESSAR</router-link>
            -->

      <div class="row" v-if="podeModificar">
        <div class="sm-12 md-6">
          <a
            class="button secondary full"
            style="margin-bottom: 10px"
            @click="show_popup = true"
            >Acessar boleto</a
          >
        </div>
        <br />
        <div class="sm-12 md-6">
          <router-link
            :to="`/financeiro/segunda-via/alterar/${boleto.codigo}`"
            class="button secondary full"
            style="margin: 0"
            >Modificar boleto</router-link
          >
        </div>
      </div>
      <div class="row" v-else>
        <div class="sm-12">
          <a
            class="button secondary full"
            style="margin: 0"
            @click="show_popup = true"
            >Acessar boleto</a
          >
        </div>
      </div>

      <Modal
        v-if="show_popup"
        @close="show_popup = false"
        :showOkButton="false"
        :showCancelButton="false"
        v-slot="{ close }">
        <PopUpBoleto
          :boleto="boleto"
          @updated="boleto => $emit('updated', boleto)"
          @close="
            e => {
              close();
              show_popup = false;
            }
          "></PopUpBoleto>
      </Modal>
    </div>
    <div class="flex flex-column flex-between p-16 w-100">
      <div class="row">
        <div class="sm-12 text-center">
          <h4 v-if="boleto.unidade">
            {{ boleto.unidade.condominio.endereco.enderecoCompleto }}
          </h4>
          <h4 v-if="boleto.imovel">
            {{ boleto.imovel.endereco.enderecoCompleto }}
          </h4>
        </div>
      </div>
      <div class="row">
        <div class="sm-6 md-3">
          <div class="flex flex-column flex-centered mt-16">
            <h5>Vencimento</h5>
            <span>{{ boleto.dataVencimento | date("dd/LL/yyyy") }}</span>
          </div>
        </div>
        <div class="sm-6 md-3">
          <div class="flex flex-column flex-centered mt-16">
            <h5>Valor</h5>
            <span>{{ boleto.valorAtualizado | number_format }}</span>
          </div>
        </div>
        <div class="sm-6 md-3">
          <div class="flex flex-column flex-centered mt-16">
            <h5>Mês</h5>
            <span>{{ boleto.competencia }}</span>
          </div>
        </div>
        <div class="sm-6 md-3">
          <div class="flex flex-column flex-centered mt-16">
            <h5>Tipo Doc</h5>
            <span>{{ boleto.tipoDOC }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Modal from "/components/Modal.vue";
import PopUpBoleto from "./popup-boleto.vue";
export default {
  props: ["boleto"],
  data() {
    return {
      show_popup: false,
    };
  },
  components: {
    Modal,
    PopUpBoleto,
  },
  filters: {
    number_format(value) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
  },
  computed: {
    podeModificar() {
      let cliente = this.$store.state.cliente;

      return (
        this.$store.getters.controleAcesso.atualizacaoDOCLinha?.acesso || false
      );
    },
  },
};
</script>
